import {Label} from 'semantic-ui-react';

import {isDev} from './environmentUtils';

const baseTypeLabels = {
  EOSGateway: 'WebEOS',
  OpenShift: 'OpenShift',
  AfsGateway: 'AFS',
  IIS8Dfs: 'DFS',
  IIS7Dfs2: 'DFS',
  IIS7: 'DFS',
  SP2013: 'SharePoint',
  SP13HNSC: 'SharePoint',
  SPCommunity: 'SharePoint',
  Drupal8: 'Drupal',
};

const productionTypeLabels = {
  WebeosSite: 'Webeos Site',
  GitlabPagesSite: 'GitLab Pages Site',
  PaasProject: 'Paas Project',
  DrupalSite: 'Drupal Site',
  AppCatalogue: 'App Catalogue',
  WordpressSite: 'Wordpress Site',
  GrafanaInstance: 'Grafana Instance',
  LegacyWordpressSite: 'WordPress (Legacy)',
  NexusInstance: 'Nexus Instance',
  DiscourseInstance: 'Discourse Instance',
  SentryInstance: 'Sentry Instance',
};

const devTypeLabels = {
  'WebeosSite-Playground': 'Webeos Site Playground',
  'GitlabPagesSite-Playground': 'GitLab Pages Site Playground',
  'PaasProject-Playground': 'Paas Project Playground',
  'DrupalSite-Playground': 'Drupal Site Playground',
  'AppCatalogue-Playground': 'App Catalogue Playground',
  'WordpressSite-Playground': 'Wordpress Site Playground',
  'GrafanaInstance-Playground': 'Grafana Instance Playground',
  'LegacyWordpressSite-Playground': 'WordPress (Legacy) Playground',
  'NexusInstance-Playground': 'Nexus Instance Playground',
  'DiscourseInstance-Playground': 'Discourse Instance Playground',
  'SentryInstance-Playground': 'Sentry Instance Playground',
};

export const typeLabel = {
  ...(isDev ? devTypeLabels : productionTypeLabels),
  ...baseTypeLabels,
};

// labelColor maps the type name displayable to the user (from the typeLabel values) to the color
export const labelColor = {
  // first are OKD4 cluster types or related
  // Web Eos Sites
  'WebeosSite': '#AD1457',
  'WebeosSite-Playground': '#AD1457',
  // Gitlab Pages Sites
  'GitlabPagesSite': '#db3700',
  'GitlabPagesSite-Playground': '#db3700',
  // Paas Sites
  'PaasProject': '#404040',
  'PaasProject-Playground': '#404040',
  // Drupal Sites
  'DrupalSite': '#0033a0',
  'DrupalSite-Playground': '#0033a0',
  // App Cat Sites
  'AppCatalogue': '#07b55b',
  'AppCatalogue-Playground': '#07b55b',
  'GrafanaInstance': '#b8580b',
  'GrafanaInstance-Playground': '#b8580b',
  'WordpressSite': '#017694',
  'WordpressSite-Playground': '#017694',
  'NexusInstance': '#00D668',
  'NexusInstance-Playground': '#00D668',
  'DiscourseInstance': '#C20000',
  'DiscourseInstance-Playground': '#C20000',
  'SentryInstance': '#b8580b',
  'SentryInstance-Playground': '#b8580b',
  'LegacyWordpressSite': '#404040',
  'LegacyWordpressSite-Playground': '#404040',
  // the rest of the types are the ones returned by the Web Services DB
  'OpenShift': '#2d8659',
  'AFS': '#800000',
  'DFS': '#673ab7',
  'SharePoint': '#0d76d9',
  'Unknown': '#A6B2C3',
};

export function getTypeLabel(type) {
  return (
    <Label
      size="small"
      basic
      style={{
        borderColor: labelColor[type] || labelColor[typeLabel[type]],
        color: labelColor[type] || labelColor[typeLabel[type]],
      }}
    >
      {typeLabel[type] ? typeLabel[type] : type}
    </Label>
  );
}
